export const UNEXPECTED_ERROR_MESSAGE = "Возникла непредвиденная ошибка";

export const parseError = (error) => {
  const result = {
    status: error?.response?.status || 532,
    errors: {},
    get $first() {
      const key = Object.keys(this.errors)[0];
      if (!key) return this.$default;
      if (Array.isArray(this.errors[key]))
        return this.errors[key][0] + ` (${key})`;
      if (typeof this.errors[key] === "string") {
        return this.errors[key] + ` (${key})`;
      }
      return this.$default;
    },
    get $default() {
      return `${UNEXPECTED_ERROR_MESSAGE} (${this.status})`;
    },
    /**
     * Возвращает объект с ошибками для переданных
     * полей. Если совпадений нет вернет undefined
     * @param {String[]} fields - название полей
     */
    getFieldsErrors(fields) {
      if (!fields || !Array.isArray(fields) || !fields.length) return;
      const { errors } = this;
      let hasFieldError = false;
      const result = fields.reduce((acc, field) => {
        if (errors[field]) {
          acc[field] = errors[field];
          hasFieldError = true;
        }
        return acc;
      }, {});

      if (hasFieldError) return result;
    },
  };
  if (error?.response?.data && typeof error?.response?.data === "object") {
    result.errors = { ...error.response.data };
  }
  return result;
};
